import { Checkbox } from "@/components/ui/checkbox";
import { Label } from "@/components/ui/label";

interface TermsCheckboxProps {
  checked: boolean;
  onCheckedChange: (checked: boolean) => void;
  disabled?: boolean;
  className?: string;
}

export function TermsCheckbox({ 
  checked, 
  onCheckedChange, 
  disabled = false,
  className = ""
}: TermsCheckboxProps) {
  return (
    <div className={`flex items-start space-x-3 ${className}`}>
      <Checkbox
        id="terms"
        checked={checked}
        onCheckedChange={onCheckedChange}
        disabled={disabled}
        className="mt-1 border-slate-300 data-[state=checked]:bg-orange-500 data-[state=checked]:border-orange-500 focus-visible:ring-orange-400/20 focus-visible:ring-2"
      />
      <Label 
        htmlFor="terms" 
        className="text-sm text-slate-600 space-grotesk leading-relaxed cursor-pointer"
      >
        I accept the{" "}
        <a 
          href="https://airtalent.co.uk/terms-conditions" 
          target="_blank" 
          rel="noopener noreferrer"
          className="text-orange-500 hover:text-orange-600 underline font-medium transition-colors"
        >
          Terms of Service
        </a>
        {" "}and{" "}
        <a 
          href="https://airtalent.co.uk/privacy-policy" 
          target="_blank" 
          rel="noopener noreferrer"
          className="text-orange-500 hover:text-orange-600 underline font-medium transition-colors"
        >
          Privacy Policy
        </a>
      </Label>
    </div>
  );
}
